import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {License} from '../restaurant-manager.models';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class LicenseService {

    constructor(private apiService: ApiService) {}

    get(): Observable<License> {
        return this.apiService.get<License>('/my-license', true).pipe(map(result => result?.id ? new License(result) : null));
    }

    getById(id: string): Observable<License> {
        return this.apiService.get<License>('/licenses/' + id, true).pipe(map(result => result?.id ? new License(result) : null));
    }

}